export enum ShiftsEnum {
    Shift_A = 'Shift A',
    Shift_B = 'Shift B',
    Shift_C = 'Shift C',
    General = 'General'
}